//#region Imports

// @angular
import {HttpClient, provideHttpClient} from '@angular/common/http';
import {EnvironmentProviders, importProvidersFrom, Provider} from '@angular/core';

// ngx-translate and the http loader
import {TranslateLoader, TranslateModule, TranslateModuleConfig} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

//#endregion

/**
 * Required for AOT compilation
 *
 * @param http HttpClient
 *
 * @returns TranslateHttpLoader
 */
const httpLoaderFactory = (http: HttpClient): TranslateHttpLoader =>
  new TranslateHttpLoader(http, 'i18n/', '.json');

/**
 * Used as a provider for TranslateLoader
 */
const translateProvider: Provider = {
  provide: TranslateLoader,
  useFactory: httpLoaderFactory,
  deps: [HttpClient],
};

/**
 * Used in TranslateModule root.
 */
const translationLoader: TranslateModuleConfig = {
  defaultLanguage: 'en',
  useDefaultLang: true,
  loader: translateProvider,
};

/**
 * Used in ApplicationConfig providers.
 *
 * Notice: provideHttpClient() is required for AOT compilation
 *
 * @returns EnvironmentProviders[]
 */
export const provideTranslation = (): EnvironmentProviders[] => [
  provideHttpClient(),
  importProvidersFrom(TranslateModule.forRoot(translationLoader)),
];
